(function () {
    'use strict';

    angular.module("imApp").factory("textileModelCategory8Service", ['$ihttp', function ($ihttp) {
        let service = {
            getTextileModelCategory8: function (parms) {
                return $ihttp.post({
                    method: 2700,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 2702,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
